import { ajax } from './helper'
class ApiService {

     getCityDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/cities/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    getWorkstationDetailList = (type) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/workStations/getCombo?type="+type
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

      getPlatformsDetailList = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/platforms/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    getAttendanceCyclesList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/attendanceCycles/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getEntyStatusComboList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/entityStatus/getEntityStatusCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getEntityTypesComboList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/entityTypes/getEntityTypeCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    



     getDepartmentsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/departments/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


        

    getWorkLocationsDetailList = (city_id,type) => {
        if(city_id!=="" && city_id!==undefined && !isNaN(city_id)){
            return new Promise((resolve, reject) => {
                const url = "/v1/workLocations/getCombo?type="+type+"&city_id="+city_id
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }else{
           return new Promise((resolve, reject) => {
                const url = "/v1/workLocations/getCombo?type="+type
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            }) 
        }
    }

    getDesignationsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/designations/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


     getKitchensDetailList = (city_id,comboType) => {

        if(city_id!=="" && city_id!==undefined && !isNaN(city_id)){
            return new Promise((resolve, reject) => {
                const url = "/v1/kitchens/getCombo?city_id="+city_id+"&combo_type="+comboType
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }else{
            return new Promise((resolve, reject) => {
                const url = "/v1/kitchens/getCombo?combo_type="+comboType
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }
        
    }  

     getKitchensScopeList = (type) => {

        if(type!=="" && type!==undefined && !isNaN(type)){
            return new Promise((resolve, reject) => {
                const url = "/v1/kitchens/getCombo?type="+type
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }else{
            return new Promise((resolve, reject) => {
                const url = "/v1/kitchens/getCombo"
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }
        
    }   


    validateEmployee = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/alreadyExistByValue"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    

    getEntyTypesList = (type) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/entityTypes/getCombo?type="+type
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getProductsList = (type,city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/products/getCombo?type="+type+"&city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    getEntyStatusList = (type) => {
            return new Promise((resolve, reject) => {
                const url = "/v1/entityStatus/getCombo?type="+type
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }


    getIssueslList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/reasons/getCombo?type=HR_ISSUE"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getEmployeesListData = (type) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/getCombo?type="+type
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getBrandsByKitchenId = (kitchen_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brands/getComboNotInKitchen?kitchen_id="+kitchen_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }    

     getClusterComboDetailList = (city_id=0,cluster_id=0) => {
        if(city_id && city_id!==null && city_id!=="" && city_id!==0 && cluster_id && cluster_id!==null && cluster_id!=="" && cluster_id!==0){
            return new Promise((resolve, reject) => {
                const url = "/v1/clusters/getCombo?city_id="+city_id+"&exclude_id="+cluster_id
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }else{
            return new Promise((resolve, reject) => {
                const url = "/v1/clusters/getCombo"
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })

        }
    }



    getReasonsListData = (type) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/reasons/getCombo?type="+type
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



     getLatestUserDetails = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/users/getLoggedInUserDetails"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
     getVendorsDetailList  = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/vendors/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
    

   
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/services/ApiService.js